import { Skeleton } from "@facade/components/ui";
import { cn } from "@facade/lib/utils";

export function AvatarWithDetailsSkeleton({
  className,
}: {
  className?: string;
}) {
  return (
    <div className={cn("flex items-center gap-3", className)}>
      <Skeleton className="size-11 rounded-full" />

      <div className="min-w-0 flex-1 space-y-2">
        <Skeleton className="h-4 w-44" />
        <Skeleton className="h-3 w-28" />
      </div>
    </div>
  );
}
